function replaceSingeQuotes(str: string, character = ''): string {
  if (typeof str !== 'string') return '';
  return str.replace(/[\u2018\u2019'"]/g, character);
}

export default replaceSingeQuotes;
